const styles = `:host {
  --goto-icon-size: var(--goto-layout-07);
  background-color: var(--goto-background-color-default);
  display: grid;
  height: 100%;
  place-items: center;
  width: 100%;
}
:host slot {
  animation: pulse 1.3s var(--goto-standard-easing) infinite;
  display: inline-flex;
}
:host ::slotted(svg) {
  height: var(--goto-icon-size);
  width: var(--goto-icon-size);
}
:host .rebranding-logo-container {
  display: none;
}

:host(.rebranding) .rebranding-logo-container {
  display: flex;
}
:host(.rebranding) .old-logo-container {
  display: none;
}
:host(.rebranding) chameleon-svg {
  animation: pulse 1.3s var(--goto-standard-easing) infinite;
  display: inline-flex;
}

@keyframes pulse {
  0% {
    transform: scaleX(1);
  }
  50% {
    transform: scale3d(1.05, 1.05, 1.05);
  }
  100% {
    transform: scaleX(1);
  }
}`; export default styles;